import useStore from '../../../sharedCode/stores/store';
import useDndStore from '../../../sharedCode/stores/dndStore';
import { showToast } from '../../../sharedCode/Utils/showToastWrapper';
import { arrayMove } from '@dnd-kit/sortable';

export const handleGroupMove = (active, over) => {
    let tabGroups = structuredClone(useStore.getState().tabGroups);
    if (!over || !active) {
        return;
    }
    let oldIndex = active.data.current.sortable.index;
    let newIndex = over.data.current.sortable.index;
    let categoryId = active.data.current.data.categoryID;

    let groupsToReoder = tabGroups.filter(
        (group) => group.categoryID === categoryId
    );
    let filteredGroups = tabGroups.filter(
        (group) => group.categoryID !== categoryId
    );
    let orderedTabGroups = arrayMove(groupsToReoder, oldIndex, newIndex);
    filteredGroups.push(...orderedTabGroups);

    useStore.getState().updateTabGroups(
        filteredGroups,
        { type: 'groups', ids: [active.id] }
        // false
        // true,
        // 400
    );
};

export const handleGroupMoveOld = (active) => {
    let { insertPosition } = useDndStore.getState();
    const [overItemId, position] = Object.entries(insertPosition).flat();

    if (!overItemId) {
        return;
    }

    let originalData = active.data.current.data;

    let tabGroups = structuredClone(useStore.getState().tabGroups);

    let removedGroup = removeGroup(originalData.id, tabGroups);

    addGroup(tabGroups, removedGroup, overItemId, position);
    // useStore.getState().setTabGroups(tabGroups);

    useStore.getState().updateTabGroups(
        tabGroups,
        { type: 'groups', ids: [originalData.id] }
        // true,
        // true,
        // 400
    );
};

function removeGroup(groupId, tabGroups) {
    let wasStacked = false;
    let parentStackId = null;
    let removedGroup = null;

    for (let i = 0; i < tabGroups.length; i++) {
        const group = tabGroups[i];
        if (group.id === groupId) {
            // Direct removal of a non-stacked group
            removedGroup = tabGroups.splice(i, 1)[0];
            break;
        } else if (group.isStacked) {
            const indexInStack = group.stackedGroups.findIndex(
                (g) => g.id === groupId
            );
            if (indexInStack !== -1) {
                wasStacked = true;
                parentStackId = group.id;
                removedGroup = group.stackedGroups.splice(indexInStack, 1)[0]; // Remove from stack

                // Check if there's only one group left in the stack
                if (group.stackedGroups.length === 1) {
                    const remainingGroup = group.stackedGroups[0];
                    // Replace the stack in tabGroups with this remaining group, effectively unstacking it
                    tabGroups[i] = remainingGroup;
                }
                break;
            }
        }
    }

    return removedGroup;
}

function addGroup(tabGroups, groupItem, overItemId, position) {
    let targetIndex = -1;
    let isWithinStack = false;
    let parentStackIndex = null;
    // Search for the target group, including within stacked groups
    for (let i = 0; i < tabGroups.length; i++) {
        const group = tabGroups[i];
        if (group.id === overItemId) {
            targetIndex = i;
            break; // Found the group at the top level
        } else if (group.isStacked) {
            const indexInStack = group.stackedGroups.findIndex(
                (g) => g.id === overItemId
            );
            if (indexInStack !== -1) {
                targetIndex = indexInStack;
                isWithinStack = true;
                parentStackIndex = i;
                break; // Found the group within a stacked group
            }
        }
    }

    if (targetIndex === -1) return; // Target group not found, just return

    if (isWithinStack) {
        // Handle insertion within the stack
        if (position === 'over') {
            tabGroups[parentStackIndex].stackedGroups.splice(
                targetIndex,
                0,
                groupItem
            );
        } else if (position === 'under') {
            tabGroups[parentStackIndex].stackedGroups.splice(
                targetIndex + 1,
                0,
                groupItem
            );
        } else if (position === 'center') {
            tabGroups[parentStackIndex].stackedGroups[targetIndex] =
                mergeGroups(
                    groupItem,
                    tabGroups[parentStackIndex].stackedGroups[targetIndex]
                );
            showToast(
                'Groups merged',
                `${groupItem.title} merged into ${tabGroups[parentStackIndex].stackedGroups[targetIndex].title}`,
                'success'
            );
        } else {
            // For 'left' or 'right', insert before or after the entire stack
            const insertPosition =
                position === 'left' ? parentStackIndex : parentStackIndex + 1;
            tabGroups.splice(insertPosition, 0, groupItem);
        }
    } else {
        // Handle top-level insertion
        if (position === 'over' || position === 'under') {
            if (!tabGroups[targetIndex].isStacked) {
                // Create a new stack
                let newStack = {
                    categoryID: groupItem.categoryID,
                    isStacked: true,
                    stackedGroups:
                        position === 'over'
                            ? [groupItem, tabGroups[targetIndex]]
                            : [tabGroups[targetIndex], groupItem]
                };
                tabGroups.splice(targetIndex, 1, newStack);
            } else {
                // Add to existing stack
                if (position === 'over') {
                    tabGroups[targetIndex].stackedGroups.unshift(groupItem);
                } else {
                    tabGroups[targetIndex].stackedGroups.push(groupItem);
                }
            }
        } else if (position === 'center') {
            tabGroups[targetIndex] = mergeGroups(
                groupItem,
                tabGroups[targetIndex]
            );
            showToast(
                'Groups merged',
                `${groupItem.title} merged into ${tabGroups[targetIndex].title}`,
                'success'
            );
        } else {
            // Handle 'left' or 'right' without creating a stack
            const insertPosition =
                position === 'left' ? targetIndex : targetIndex + 1;
            tabGroups.splice(insertPosition, 0, groupItem);
        }
    }
}

const mergeGroups = (draggedGroup, dropGroup) => {
    dropGroup.tabs.push(...draggedGroup.tabs);
    return dropGroup;
};
